<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-svg-icon-docs-preview></ui-svg-icon-docs-preview></p>
<h1 id="description">Description</h1>
<p>Icon using our iconset at Icomoon.com as source external svg file.
To change size just set another font-size on the element.</p>
<h1 id="usage">Usage</h1>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ui-svg-icon</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"button"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-icon</span>&gt;</span>
</code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">icon</td>
<td align="left">Name of icon to be display. Case insensitive.</td>
</tr>
<tr>
<td align="left">fill</td>
<td align="left">Fill color of the icon. Pass an array if you want to apply multiple.</td>
</tr>
<tr>
<td align="left">set</td>
<td align="left">From which icon set the icon should load.</td>
</tr>
</tbody></table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
